export default __webpack_public_path__ + "assets/images/portrait_youth_female_199.jpg";